export default __webpack_public_path__ + "static/media/andrej-lisakov-3A4XZUopCJA-unsplash.bc03e4df.jpg";